(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casa-founders-letter-v2"] && !Shopify.designMode) return;
  try {
    
  // GA4: un clic su una porta della lettera. link_url e link_text sono dimensioni predefinite di GA4,
  // quindi si leggono nei rapporti senza registrare dimensioni personalizzate. gtag lo carica l'app
  // Google & YouTube e rispetta già il consenso: senza gtag (o senza consenso) non parte niente.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-letter-door]');
    if (!link || typeof window.gtag !== 'function') return;
    window.gtag('event', 'letter_door_click', {
      door_number: Number(link.dataset.letterDoor),
      link_url: link.href,
      link_text: link.querySelector('.casa-letter__question')?.textContent.trim(),
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-founders-letter"] && !Shopify.designMode) return;
  try {
    
  // GA4: un clic su una porta della lettera. link_url e link_text sono dimensioni predefinite di GA4,
  // quindi si leggono nei rapporti senza registrare dimensioni personalizzate. gtag lo carica l'app
  // Google & YouTube e rispetta già il consenso: senza gtag (o senza consenso) non parte niente.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-letter-door]');
    if (!link || typeof window.gtag !== 'function') return;
    window.gtag('event', 'letter_door_click', {
      door_number: Number(link.dataset.letterDoor),
      link_url: link.href,
      link_text: link.querySelector('.casa-letter__question')?.textContent.trim(),
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-luxury"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var content = document.querySelector('.hero__content');
    if (!content) return;
    requestAnimationFrame(function () {
      content.classList.add('is-ready');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
